import "./CharacterPortrait.css";
import type { ICharacterPortraitProps, CharacterAvatarSize, CharacterPortraitLayout, ICharacterStatChip } from "../../../models/ICharacter";
import { getCharacterPortraitCssVars } from "../CharacterHelpers";
import { CharacterAvatar } from "./CharacterAvatar";
import { StatTile } from "../AbilityStats/StatTile";

function clampStats(stats: ICharacterStatChip[] | undefined): ICharacterStatChip[] {
    if (!stats || stats.length === 0) {
        return [];
    }

    if (stats.length > 3) {
        console.warn(`CharacterPortrait: received ${stats.length} stats; only first 3 will be shown.`);
    }

    return stats.slice(0, 3);
}

function statLabelFromKey(key: ICharacterStatChip["key"]): string {
    return key.toUpperCase();
}

export function CharacterPortrait(props: ICharacterPortraitProps): JSX.Element {
    const size: CharacterAvatarSize = props.size ?? "md";
    const layout: CharacterPortraitLayout = props.layout ?? "standard";
    const stats = clampStats(props.stats);
    const showStatsRing = props.showStatsRing ? props.showStatsRing : false;
    const canClick = Boolean(props.onClick);
    const charName = ((props.name === undefined || props.name == null || props.name.trim() === "") ? "The Unnamed Hero" : props.name);

    // Layout currently influences what you render (not token values).
    const showSubtitle = layout !== "compact" && Boolean(props.subtitle);
    const showStats = layout !== "compact" && stats.length > 0;

    return (
        <div
            className={`characterPortraitBlock layout-${layout} ${canClick ? "clickable" : ""}`}
            style={getCharacterPortraitCssVars(size, layout)}
            onClick={props.onClick}
        >
            <CharacterAvatar
                size={size}
                imageUrl={props.imageUrl}
                name={charName}
                level={props.level}
                status={props.status}
                // we keep toggles defaulted; spec says level always visible
            />

            <div className="characterPortraitText">
                <div className="characterPortraitName">
                    {charName}
                </div>

                {showSubtitle ? (
                    <div className="characterPortraitSubtitle">
                        {props.subtitle}
                    </div>
                ) : null}

                {showStats ? (
                    <div className="characterPortraitStatsRow">
                        {stats.map((stat) => (
                            <StatTile 
                                key={stat.key}
                                label={stat.label ?? statLabelFromKey(stat.key)} 
                                value={stat.value} 
                                size="xs" 
                                variant="page" 
                                showValueRing={showStatsRing} 
                                showBonusBadge={false}
                            />
                        ))}
                    </div>
                ) : null}
            </div>
        </div>
    );
}
